import React from "react";

const LeaveTypesInPolicyListData = ({ policyData }) => {
  return (
    <>
      <table>
        <thead>
          <td>policy name</td>
          <td>policy type</td>
        </thead>
        {policyData &&
          policyData.map((policy) => (
            <tr>
              <td>{policy.policy_name}</td>
              <td>{policy.policy_type}</td>
            </tr>
          ))}
      </table>
    </>
  );
};

export default LeaveTypesInPolicyListData;
